import React from "react";

const iconLink =
  "inline-flex items-center justify-center w-8 h-8 rounded-md text-gray-500 hover:text-[#064E8D] hover:bg-gray-100 transition-colors no-underline";
const iconMuted =
  "inline-flex items-center justify-center w-8 h-8 rounded-md text-gray-500 hover:text-gray-800 hover:bg-gray-100 transition-colors";

const FreightProfileStatusDtActions = ({ row, getNavigate, onToggleStatus }) => {
  const id = row?.id;
  if (id == null) return null;

  const go = (path) => {
    const nav = getNavigate?.();
    if (typeof nav === "function") {
      nav(path);
      return;
    }
    window.location.assign(path);
  };

  const active = String(row?.status) === "1";
  const title = active ? "Deactivate" : "Activate";

  return (
    <div className="flex flex-row flex-wrap items-center justify-center gap-1">
      <a
        href={`/freight/profile_status/${id}/edit`}
        className={iconLink}
        title="Edit"
        onClick={(e) => {
          e.preventDefault();
          go(`/freight/profile_status/${id}/edit`);
        }}
      >
        <i className="fas fa-pen text-sm" aria-hidden />
      </a>
      <button type="button" className={iconMuted} title={title} onClick={() => onToggleStatus?.(row)}>
        <i className={`fas ${active ? "fa-toggle-on text-emerald-600" : "fa-toggle-off"} text-sm`} aria-hidden />
      </button>
    </div>
  );
};

export default FreightProfileStatusDtActions;
